import webBiLogger from '@wix/web-bi-logger';
import { appDashboardHomePageClickSrc96Evid49, devCenterInstallerSdkModalUnmountedSrc96Evid217, devCenterInstallerSdkNewConsentModalCtaClickSrc96Evid28, devCenterInstallerSdkNewConsentModalLoadedSrc96Evid27, devCenterInstallerSdkNewErrorModalLoadedSrc96Evid22, devCenterInstallerSdkNewInstallCallSentSrc96Evid23, devCenterInstallerSdkNewInstallFailedSrc96Evid25, devCenterInstallerSdkNewInstallInitiatedSrc96Evid26, devCenterInstallerSdkNewInstallSuccessSrc96Evid24, devCenterInstallerSdkNewLegacyInstallerFallbackInitiatedSrc96Evid192, devCenterInstallerSdkOAuthAppUrlEndSrc96Evid207, devCenterInstallerSdkOAuthAppUrlStartSrc96Evid206, devCenterInstallerSdkOAuthRedirectUrlEndSrc96Evid209, devCenterInstallerSdkOAuthRedirectUrlStartSrc96Evid208, devCenterInstallerSdkPostInstallationNavigationSrc96Evid210, devCenterTestMyAppModalCtaClickSrc96Evid220, devCenterTestMyAppModalLoadedSrc96Evid219 } from '@wix/bi-logger-dev-center-data/v2';
import { devCenterDashboardClickOnLearnMore } from '@wix/bi-logger-app-market-data/v2';
import isUndefined from 'lodash/isUndefined';
let logger;
const route = window.location.pathname.split('/').pop();
export const initBiLogger = _ref => {
  let {
    appId,
    tenantId,
    platform,
    version,
    tenantType,
    silentInstall,
    avoidPostInstallation,
    correlationId,
    installationId,
    isMarketingConsent,
    pageId
  } = _ref;
  logger = webBiLogger.factory().logger();
  logger.updateDefaults({
    app_id: appId,
    installation_id: installationId,
    install_origin: window.location.href,
    route: window.location.pathname,
    correlation_id: correlationId,
    is_silent_install: silentInstall,
    avoid_post_installation: avoidPostInstallation,
    platform,
    version: isUndefined(version) ? 'undefined' : version,
    external_content_mode: isMarketingConsent ? 'marketing_consent' : null,
    is_advance_oauth: null,
    is_external_dashboard: null,
    ...(tenantType === 'SITE' && {
      msid: tenantId
    }),
    page_id: pageId ? pageId : null
  });
};
export const updateBiLoggerDefaults = params => {
  Object.entries(params).forEach(_ref2 => {
    let [key, value] = _ref2;
    if (!isUndefined(value)) {
      logger.updateDefaults({
        [key]: value
      });
    }
  });
};
export const reportInstallerInitiated = () => {
  var _logger;
  (_logger = logger) == null || _logger.report(devCenterInstallerSdkNewInstallInitiatedSrc96Evid26({}));
};
export const reportInstallSuccess = _ref3 => {
  var _logger2;
  let {
    requestId,
    instanceId
  } = _ref3;
  return (_logger2 = logger) == null ? void 0 : _logger2.report(devCenterInstallerSdkNewInstallSuccessSrc96Evid24({
    request_id: requestId,
    instance_id: instanceId
  }));
};
export const reportInstallRequestFired = () => {
  var _logger3;
  return (_logger3 = logger) == null ? void 0 : _logger3.report(devCenterInstallerSdkNewInstallCallSentSrc96Evid23({}));
};
export const reportInstallFailed = requestId => {
  var _logger4;
  return (_logger4 = logger) == null ? void 0 : _logger4.report(devCenterInstallerSdkNewInstallFailedSrc96Evid25({
    request_id: requestId
  }));
};
export const reportErrorModalLoaded = (errorReason, errorContentType, requestId) => {
  var _logger5;
  return (_logger5 = logger) == null ? void 0 : _logger5.report(devCenterInstallerSdkNewErrorModalLoadedSrc96Evid22({
    error_content_type: errorContentType,
    error_reason: errorReason,
    request_id: requestId
  }));
};
export const reportErrorModalCTAClick = (ctaName, errorReason) => {
  var _logger6;
  return (_logger6 = logger) == null ? void 0 : _logger6.report(appDashboardHomePageClickSrc96Evid49({
    cta_name: ctaName,
    error_reason: errorReason,
    error_content_type: errorReason
  }));
};
export const reportModalShown = modalType => {
  var _logger7;
  return (_logger7 = logger) == null ? void 0 : _logger7.report(devCenterInstallerSdkNewConsentModalLoadedSrc96Evid27({
    modal_type: modalType
  }));
};
export const reportModalUnmounted = (modalType, isBulkInstallApiTriggered) => {
  var _logger8;
  return (_logger8 = logger) == null ? void 0 : _logger8.report(devCenterInstallerSdkModalUnmountedSrc96Evid217({
    modal_type: modalType,
    was_bulk_install_invoked: isBulkInstallApiTriggered
  }));
};
export const reportModalCtaClick = _ref4 => {
  var _logger9;
  let {
    ctaName,
    modalType
  } = _ref4;
  return (_logger9 = logger) == null ? void 0 : _logger9.report(devCenterInstallerSdkNewConsentModalCtaClickSrc96Evid28({
    modal_type: modalType,
    cta_name: ctaName
  }));
};
export const reportModalAddDevSiteCtaClick = _ref5 => {
  var _logger10;
  let {
    ctaName,
    modalType
  } = _ref5;
  return (_logger10 = logger) == null ? void 0 : _logger10.report(devCenterTestMyAppModalCtaClickSrc96Evid220({
    modal_type: modalType,
    cta_name: ctaName,
    route
  }));
};
export const reportModalAddDevSiteLoaded = _ref6 => {
  var _logger11;
  let {
    modalType
  } = _ref6;
  return (_logger11 = logger) == null ? void 0 : _logger11.report(devCenterTestMyAppModalLoadedSrc96Evid219({
    modal_type: modalType,
    route
  }));
};
export const reportClickOnLearnMore = _ref7 => {
  var _logger12;
  let {
    locationSection,
    clickName,
    targetUrl
  } = _ref7;
  return (_logger12 = logger) == null ? void 0 : _logger12.report(devCenterDashboardClickOnLearnMore({
    location_section: locationSection,
    click_name: clickName,
    target_url: targetUrl,
    loaction: route
  }));
};
export const reportAppUrlStart = _ref8 => {
  var _logger13;
  let {
    url
  } = _ref8;
  return (_logger13 = logger) == null ? void 0 : _logger13.report(devCenterInstallerSdkOAuthAppUrlStartSrc96Evid206({
    url
  }));
};
export const reportAppUrlEnd = _ref9 => {
  var _logger14;
  let {
    url
  } = _ref9;
  return (_logger14 = logger) == null ? void 0 : _logger14.report(devCenterInstallerSdkOAuthAppUrlEndSrc96Evid207({
    url
  }));
};
export const reportRedirectUrlStart = _ref10 => {
  var _logger15;
  let {
    url
  } = _ref10;
  return (_logger15 = logger) == null ? void 0 : _logger15.report(devCenterInstallerSdkOAuthRedirectUrlStartSrc96Evid208({
    url
  }));
};
export const reportRedirectUrlEnd = _ref11 => {
  var _logger16;
  let {
    url
  } = _ref11;
  return (_logger16 = logger) == null ? void 0 : _logger16.report(devCenterInstallerSdkOAuthRedirectUrlEndSrc96Evid209({
    url
  }));
};
export const reportPostInstallation = _ref12 => {
  var _logger17;
  let {
    destination
  } = _ref12;
  return (_logger17 = logger) == null ? void 0 : _logger17.report(devCenterInstallerSdkPostInstallationNavigationSrc96Evid210({
    destination
  }));
};
export const reportLegacyInstallerInitiated = () => {
  var _logger18;
  return (_logger18 = logger) == null ? void 0 : _logger18.report(devCenterInstallerSdkNewLegacyInstallerFallbackInitiatedSrc96Evid192({}));
};
//# sourceMappingURL=bi.js.map